import {BASE_SINGLE_ARG_NUMERIC_FUNCTION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_SINGLE_ARG_NUMERIC_FUNCTION,
  name: 'ABS',
  description: 'Absolute value of each number in a column or of a single number.',
  shortDescription: 'Absolute value',
} satisfies AnalysisFunction;
